import { IAllTrucks, ICreateTruckRequestData, IRefuellingData, ITruckBalanceProduct, ITruckDriving, ITruckType } from './../../models/models'
import { api } from '../api'
import { ITruck, ITable, ServerResponse, IDriving, IFillTruckInfo } from '../../models/models'

export const trucksApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTrucks: builder.query<ITable<ITruck>, any>({
			query: (params) => ({
				url: 'trucks',
				params,
			}),
			providesTags: ['truck'],
			transformResponse: (response: ServerResponse<ITable<ITruck>>) => response.data,
		}),
		getTractors: builder.query<ITable<ITruck>, any>({
			query: (params) => ({
				url: 'trucks?tractorUnit=1',
				params,
			}),
			providesTags: ['truck'],
			transformResponse: (response: ServerResponse<ITable<ITruck>>) => response.data,
		}),
		getTruckById: builder.query<ITruck, { id: string | number }>({
			query: ({ id }) => ({
				url: `trucks/${id}`,
			}),
			providesTags: ['truck'],
			transformResponse: (response: ServerResponse<ITruck>) => response.data,
		}),
		getTruckDrivings: builder.query<ITable<ITruckDriving>, any>({
			query: ({ id, ...params }) => ({
				url: `trucks/${id}/balance/history`,
				params,
			}),
			transformResponse: (response: ServerResponse<ITable<ITruckDriving>>) => ({
				...response.data,
				data: response.data.data.map((i) => ({ ...i, entityId: i.id })),
			}),
		}),
		getTruckTypes: builder.query<ITable<ITruckType>, any>({
			query: () => ({
				url: `trucks/types`,
			}),
			providesTags: ['truck-type'],
			transformResponse: (response: ServerResponse<ITable<ITruckType>>) => response.data,
		}),
		createTruck: builder.mutation<ITruck, { data: FormData }>({
			query: ({ data }) => ({
				url: 'trucks',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['truck'],
			transformResponse: (response: ServerResponse<ITruck>) => response.data,
		}),
		editTruck: builder.mutation<ITruck, { id: string | number; data: FormData }>({
			query: (body) => ({
				url: `trucks/${body.id}`,
				method: 'POST',
				body: body.data,
			}),
			invalidatesTags: ['truck'],
			transformResponse: (response: ServerResponse<ITruck>) => response.data,
		}),
		changeTruckStatus: builder.mutation<ITruck, { id: string | number; data: string }>({
			query: (body) => ({
				url: `trucks/${body.id}/status`,
				method: 'PUT',
				body: { status: body.data },
			}),
			invalidatesTags: ['truck', 'dashboard'],
			transformResponse: (response: ServerResponse<ITruck>) => response.data,
		}),
		changeVisibleTrucks: builder.mutation<ServerResponse<any>, any>({
			query: (body) => ({
				url: 'trucks/view',
				method: 'PUT',
				body,
			}),
		}),
		getFillTruck: builder.query<IFillTruckInfo, { type: string, id: number, regionId: string}>({
			query: ({ type, id, regionId }) => ({
				url: `fill_truck_info`,
				params: {
					[`${type}Id`]: id,
					regionId
				}
			}),
			transformResponse: (response: ServerResponse<IFillTruckInfo>) => response.data,
		}),
		refuellTruck: builder.mutation<{ status: string }, IRefuellingData>({
			query: (body) => ({
				url: 'refuelling',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['truck'],
		}),
		getTruckBalance: builder.query<ITruckBalanceProduct[], any>({
			query: ({ id }) => ({
				url: `trucks/${id}/balance`,
			}),
			transformResponse: (response: ServerResponse<{ products: ITruckBalanceProduct[] }>) => response.data.products,
			providesTags: ['truck'],
		}),
		changeTruckBalance: builder.mutation<ServerResponse<{ products: ITruckBalanceProduct[] }>, { id: number; data: { id: number; balance: number }[] }>({
			query: (body) => ({
				url: `trucks/${body.id}/balance`,
				method: 'PUT',
				body: {
					products: body.data,
				},
			}),
			invalidatesTags: ['truck'],
		}),
		updateTruckType: builder.mutation<ServerResponse<ITruckType>, ITruckType>({
			query: ({ id, ...data }) => ({
				url: `trucks/types/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['truck-type'],
		}),
		createTruckType: builder.mutation<ServerResponse<ITruckType>, Omit<ITruckType, 'id'>>({
			query: (data) => ({
				url: 'trucks/types',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['truck-type'],
		}),
		getAllTrucksPosition: builder.query<IAllTrucks, any>({
			query: (params) => ({
				url: 'dashboard',
				params
			}),
			providesTags: ['dashboard'],
			transformResponse: (response: ServerResponse<IAllTrucks>) => response.data,
		}),
	}),
})

export const {
	useGetTrucksQuery,
	useGetTractorsQuery,
	useGetTruckByIdQuery,
	useGetTruckDrivingsQuery,
	useGetTruckTypesQuery,
	useCreateTruckMutation,
	useEditTruckMutation,
	useChangeTruckStatusMutation,
	useChangeVisibleTrucksMutation,
	useGetFillTruckQuery,
	useRefuellTruckMutation,
	useGetTruckBalanceQuery,
	useChangeTruckBalanceMutation,
	useUpdateTruckTypeMutation,
	useCreateTruckTypeMutation,
	useGetAllTrucksPositionQuery,
} = trucksApi
